<form class="account-form needs-validation" novalidate [formGroup]="securityForm">
  <div class="account-form__field">
    <label for="emailAddress" class="account-form__label">Email address</label>
    <div class="position-relative">
      <input
        type="email"
        id="emailAddress"
        class="form-control form-control-lg"
        [class.is-invalid]="formsubmit && form.emailAddress.errors"
        [attr.aria-invalid]="formsubmit && !!form.emailAddress.errors"
        [attr.aria-describedby]="formsubmit && form.emailAddress.errors ? 'emailAddress-error' : null"
        placeholder="mary@mail.com"
        maxlength="254"
        formControlName="emailAddress"
        #emailAddress />
      @if (formsubmit && form.emailAddress.errors) {
        <div class="account-form__error" id="emailAddress-error" role="alert">
          @if (form.emailAddress.errors['required']) {
            <span>Email address is required.</span>
          } @else if (form.emailAddress.errors['maxlength']) {
            <span>Email address is too long. Use 254 characters or fewer.</span>
          } @else if (form.emailAddress.errors['email']) {
            <span>Enter a valid email address (e.g. mary&#64;mail.com).</span>
          }
        </div>
      }
    </div>
  </div>

  <div class="account-form__field">
    <label for="newPassword" class="account-form__label">Password</label>
    <div class="account-form__password">
      <input
        id="newPassword"
        class="form-control form-control-lg"
        [class.is-invalid]="formsubmit && form.newPassword.errors"
        placeholder="Create a password"
        [type]="showPassword() ? 'text' : 'password'"
        formControlName="newPassword"
        #newPassword />
      <button
        type="button"
        class="account-form__toggle"
        [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
        [attr.aria-pressed]="showPassword()"
        (click)="togglePassword()">
        <i class="bx" [class.bx-show]="!showPassword()" [class.bx-hide]="showPassword()" aria-hidden="true"></i>
      </button>
    </div>

    @if (passwordStrength().level !== 'empty') {
      <div class="account-form__strength" aria-live="polite">
        <div class="account-form__strength-bar" [attr.data-level]="passwordStrength().level">
          <span class="account-form__strength-fill" [style.width.%]="(passwordStrength().score / 5) * 100"></span>
        </div>
        <span class="account-form__strength-label">{{ passwordStrength().level | titlecase }} password</span>
      </div>
    }

    <ul class="account-form__requirements">
      @for (req of passwordRequirements(); track req.label) {
        <li [class.is-met]="req.met">
          <i class="bx" [class.bx-check]="req.met" [class.bx-x]="!req.met" aria-hidden="true"></i>
          {{ req.label }}
        </li>
      }
    </ul>

    @if (formsubmit && form.newPassword.errors?.['required']) {
      <div class="account-form__error account-form__error--static">Password is required.</div>
    }
    @if (formsubmit && form.newPassword.errors?.['minlength']) {
      <div class="account-form__error account-form__error--static">Password is too short.</div>
    }
  </div>

  <div class="account-form__field">
    <label for="confirmPassword" class="account-form__label">Confirm password</label>
    <div class="account-form__password">
      <input
        id="confirmPassword"
        class="form-control form-control-lg"
        [class.is-invalid]="formsubmit && (form.confirmPassword.errors || passwordsMismatch)"
        placeholder="Re-enter your password"
        [type]="showConfirmPassword() ? 'text' : 'password'"
        formControlName="confirmPassword"
        #confirmPassword />
      <button
        type="button"
        class="account-form__toggle"
        [attr.aria-label]="showConfirmPassword() ? 'Hide confirm password' : 'Show confirm password'"
        [attr.aria-pressed]="showConfirmPassword()"
        (click)="toggleConfirmPassword()">
        <i
          class="bx"
          [class.bx-show]="!showConfirmPassword()"
          [class.bx-hide]="showConfirmPassword()"
          aria-hidden="true"></i>
      </button>
    </div>
    @if (passwordsMismatch) {
      <div class="account-form__error account-form__error--static">Passwords do not match.</div>
    }
  </div>

  <div class="account-form__actions">
    <button type="submit" class="btn btn-primary account-form__submit" (click)="updateSettings()">
      Create account
    </button>
    <a href="/login" class="account-form__login-link">Already have an account? Log in</a>
  </div>
</form>
